import React, { useState } from "react";
import { createDestination } from "../../api/Destination";
import Swal from "sweetalert2";
import { Modal } from "bootstrap";

const CreateDestination = ({ onSuccess }) => {
  const [destination, setDestination] = useState({
    destination_name: "",
  });

  const handleChange = (e) => {
    setDestination({
      ...destination,
      id: destination?.id,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const response = createDestination(destination);
    response
      .then((res) => {
        if (res.status === 200) {
          Swal.fire({
            title: "Destination Created!",
            text: "You have successfully created a destination!",
            icon: "success",
            draggable: true,
            timer: 1000,
          });
          onSuccess(res);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="text-left">
        <div className="form-group">
          <label htmlFor="exampleInputDestination">Destination Name</label>
          <input
            type="text"
            className="form-control"
            name="destination_name"
            onChange={handleChange}
          />
        </div>
        <button type="submit" className="btn btn-primary text-right">
          Save
        </button>
      </form>
    </>
  );
};

export default CreateDestination;
